module.exports = __webpack_public_path__ + "static/media/rishik-durvasula.5f53bcaa.png";